@if (
  {
    loading: loading$ | async,
    users: users$ | async,
    retailProvider: retailProvider$ | async,
  };
  as pageData
) {
  <glxy-page [isLoading]="pageData.loading" [displayMode]="displayMode">
    <glxy-page-toolbar class="non-printable approve-toolbar">
      @if (logoUrl$ | async; as logoUrl) {
        <glxy-page-title>
          <span class="logo"><img [src]="logoUrl" alt="" /></span>
        </glxy-page-title>
      }

      @if (order$ | async; as order) {
        <glxy-page-actions>
          <bc-language-selector></bc-language-selector>
          <button
            mat-button
            matTooltip="{{ 'LIB_ORDERS.COMMON.ORDERS.PRINT' | translate }}"
            (click)="onPrint(order.orderId)"
          >
            <mat-icon>print</mat-icon>
          </button>
        </glxy-page-actions>
      }
    </glxy-page-toolbar>
    <glxy-page-wrapper>
      <orders-page
        data-testid="order-page-component"
        [loading]="pageData.loading"
        [error]="error$ | async"
        [submitDisabled]="disableSubmitButton$ | async"
        [order]="order$ | async"
        [title]="title"
        [subtitle]="subtitle"
        [orderDetailAgreements]="orderDetailAgreements$ | async"
        [orderFormOptions]="orderFormOptions$ | async"
        [orderConfig]="orderConfig$ | async"
        [partnerName]="partnerName$ | async"
        [userOptions]="pageData.users"
        [fileUploadUrl]="fileUploadUrl"
        [retailProvider]="pageData.retailProvider"
        [stripeKey]="stripeKey"
        [expandDropdowns]="expandDropdowns"
        (isApproved)="onApprove($event)"
        (isDeclined)="onDecline($event)"
      >
      </orders-page>
    </glxy-page-wrapper>
  </glxy-page>
}
